import React from 'react'
import { useStyles } from './styles'
import { FormProvider, useForm, useFormContext } from 'react-hook-form'
import { InputCheck, SelectAnimalFetchInput, Button } from 'src/components'
import { PageTitle } from 'src/components/PageTitle'
import { CreateWeightForm, weightSchema } from 'src/@types/validations/Animal'
import { yupResolver } from '@hookform/resolvers/yup'
import { FormattedOption } from 'src/dto/animal.dto'
import { useWeighing } from './hooks/useWeighing'

import { StandardWeighingFields } from './StandardWeighingFields'
import { TapeWeighingFields } from './TapeWeighingFields'

export const Weighing: React.FC = () => {
  const methods = useForm<CreateWeightForm>({
    resolver: yupResolver(weightSchema),
    defaultValues: {
      tipoPesagem: 'pesagem',
      fitaComprimento: '0',
      fitaPerimetro: '0',
      peso: '0'
    }
  })

  return (
    <FormProvider {...methods}>
      <WeighingComponent />
    </FormProvider>
  )
}

const WeighingComponent: React.FC = () => {
  const styles = useStyles()

  const {
    watch,
    setValue,
    clearErrors,
    formState: { errors },
    handleSubmit
  } = useFormContext<CreateWeightForm>()

  const { onSubmit, isSaving } = useWeighing()
  const weighingType = watch('tipoPesagem')

  return (
    <>
      <PageTitle title='Pesagem' />

      <form onSubmit={handleSubmit(onSubmit)}>
        <section className={styles.section}>
          <div className={styles.checkInputContainer}>
            <InputCheck
              id='pesagem'
              value='pesagem'
              label='Pesagem'
              name='tipoPesagem'
              checked={watch('tipoPesagem') === 'pesagem'}
              error={errors?.tipoPesagem?.message}
              onChange={(e) => {
                const value = e.target.value
                setValue('tipoPesagem', value)

                setValue('fitaPerimetro', '')
                setValue('fitaComprimento', '')
                setValue('peso', '')
              }}
            />

            <InputCheck
              id='pesagem-fita'
              value='pesagem_fita'
              label='Pesagem com fita'
              name='tipoPesagem'
              checked={watch('tipoPesagem') === 'pesagem_fita'}
              onChange={(e) => {
                const value = e.target.value
                setValue('tipoPesagem', value)

                setValue('peso', '')
                setValue('perimetro', '')
              }}
            />
          </div>

          <div style={{ marginTop: 16 }}>
            <SelectAnimalFetchInput
              label='Animal'
              selectBy='id'
              showBy={['cdn', 'nome']}
              hidden={['MT', 'VD']}
              value={watch('idAnimal') || ''}
              error={errors?.idAnimal?.message}
              placeholder='Selecionar animal'
              onChange={(item: FormattedOption) => {
                setValue('idAnimal', item.id)
                clearErrors('idAnimal')
              }}
            />

            {weighingType === 'pesagem' && <StandardWeighingFields />}
            {weighingType === 'pesagem_fita' && <TapeWeighingFields />}
          </div>
        </section>

        <div className={styles.formActions}>
          <Button className={styles.buttonWrapper} type='submit' disabled={isSaving} isLoading={isSaving}>
            Salvar
          </Button>
        </div>
      </form>
    </>
  )
}
